'use strict';

angular.module('atex.dam').controller('DamJsonCompareController', ['$rootScope', '$modal', '$state', '$scope','ObjectDiff','configuration',
    function ($rootScope, $modal, $state, $scope, ObjectDiff) {

      $scope.yourObjectOne = JSON.parse(JSON.stringify(removeEmpty(removeProp($rootScope.leftRev,"version"))));
      $scope.yourObjectTwo = JSON.parse(JSON.stringify(removeEmpty(removeProp($rootScope.rightRev, "version"))));
      $scope.diffValueChanges = ObjectDiff.toJsonDiffView(ObjectDiff.diffOwnProperties($scope.yourObjectOne, $scope.yourObjectTwo));

      $scope.doCancel = function() {
        $state.go('list.versions', { 'id' : $rootScope.idSelectedVersion });
      };
}]);

function removeEmpty(obj) {
  return Object.keys(obj)
    .filter(function (k) {
      return obj[k] !==null;
    })
    .reduce(function (acc, k) {
      acc[k] = typeof obj[k] === "object" ? removeEmpty(obj[k]) : obj[k];
      return acc;
    }, {});
}

function removeProp(obj, propToDelete) {
  for (var property in obj) {
    if (typeof obj[property] === "object") {
      var objectToCheck = obj[property];
      delete obj.property;
      var newJsonData= removeProp(obj[property], propToDelete);
      obj[property]= newJsonData;
    } else {
      if (property === propToDelete) {
        delete obj[property];
      }
    }
  }
  return obj;
}